<template>
  <section v-if="firstComment" class="comments card">
    <h3 class="title flex gap-1">
      <span>{{ $t('product_reviews') }}</span>
      <span>{{ props.productComments?.avg_rating }}</span>
      <span>({{ props.productComments?.total_count }})</span>
    </h3>
    <div class="-mx-5">
      <comment-card :comment="firstComment" />
    </div>
    <div class="more-comments">
      <content-viewer :title="$t('product_reviews')" modal-class="min-w-50dvw max-w-75dvw w-840px">
        <template #trigger="{ open }">
          <nd-button class="mx-auto active" size="small" type="text" @click="open">{{ $t('all_show_more_review') }}</nd-button>
        </template>
        <template #default>
          <comments-detail class="-mx-5" :product="product" :product-comments="props.productComments" />
        </template>
      </content-viewer>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { UiProductInfo } from '@/types/product'
import type { FreviewReviewResponse } from '@/types/api'

import CommentCard from '@/components/comment/comment-card.vue'
import ContentViewer from '@/components/common/content-viewer.vue'
import CommentsDetail from '@/components/comment/comments-detail.vue'

const props = defineProps<{
  product: UiProductInfo
  productComments: FreviewReviewResponse
}>()

const firstComment = computed(() => props.productComments?.comment?.[0])
</script>

<style lang="scss" scoped></style>
